exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".backdrop-container[data-v-c9ab36dc],.backdrop[data-v-c9ab36dc]{position:fixed;top:0;right:0;bottom:0;left:0;z-index:100}.backdrop[data-v-c9ab36dc]{background:#000;opacity:.45}.backdrop.fade-enter-to[data-v-c9ab36dc],.backdrop.fade-leave[data-v-c9ab36dc]{opacity:.45}.backdrop-message[data-v-c9ab36dc]{position:absolute;top:50%;right:0;bottom:0;left:0;font-size:1.5em;font-weight:600;color:#fff;text-align:center;z-index:1000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c9ab36dc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/backdrop/style.scss
// module id = 606
// module chunks = 0